export default "__VITE_ASSET__AHDbpNvV__"